import { render, staticRenderFns } from "./TeamInviteView.vue?vue&type=template&id=1edea206&scoped=true"
import script from "./TeamInviteView.vue?vue&type=script&lang=js"
export * from "./TeamInviteView.vue?vue&type=script&lang=js"
import style0 from "./TeamInviteView.vue?vue&type=style&index=0&id=1edea206&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1edea206",
  null
  
)

export default component.exports